// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"YouTubeEmbed_wrapper__G2RLf","video":"YouTubeEmbed_video__ontzq"};